module.exports = __webpack_public_path__ + "static/opportunity-social-60020437787f15b29bb2b944de44d30c.jpg";